import Slider from "react-slick";
import Link from 'next/link'
import  Image  from 'next/image'
import params from '../data/params'

export default function CarouselContent({ categories }) {

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    // variableWidth: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    // focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 1099,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: false
        }
      },
    ]    
  }

return (
    <div className="slides position-relative">
      <Slider {...settings} >
        {categories.map(function(category) {
          var slug = ""
          if (category.slug == "recipes")
            slug = category.slug
          else
            slug = "/category/" + category.slug
          return (
            <div key={category.id}>
              <Link href={slug}>
                <a className="cardContainerContent d-block">
                  {/* <Image layout="intrinsic" width={286} height={150} src ={category.thumbnail ? category.thumbnail : params.noimage} placeholder="blur"/> */}
                  <img width={286} height={150} src ={category.thumbnail ? category.thumbnail : params.noimage} className="img-fluid"/>
                  <p className="d-flex position-absolute align-items-center justify-content-center w-100 text-white catText"><strong className="text-center px-3">{category.name}</strong></p>
                </a>
              </Link>
            </div>
          );
        })}
      </Slider >
      <style jsx>{`
        .catText strong{
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
}
